import { render, staticRenderFns } from "./ResultScreen.vue?vue&type=template&id=9afb3ac6&scoped=true"
import script from "./ResultScreen.vue?vue&type=script&lang=js"
export * from "./ResultScreen.vue?vue&type=script&lang=js"
import style0 from "@pds/button/button.min.css?vue&type=style&index=0&id=9afb3ac6&prod&scoped=true&lang=css&external"
import style1 from "./ResultScreen.vue?vue&type=style&index=1&id=9afb3ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afb3ac6",
  null
  
)

export default component.exports